import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { Box, Typography, Container } from '@mui/material';
import '../../styles/amplify-theme.css';

interface LoginPageProps {
  children: React.ReactNode;
}

const LoginPage: React.FC<LoginPageProps> = ({ children }) => {
  return (
    <Authenticator
      hideSignUp={true}
      components={{
        Header() {
          return (
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography 
                variant="h4" 
                component="h1" 
                sx={{ 
                  color: '#252F3E',
                  fontWeight: 600,
                  mb: 1
                }}
              >
                Monthly Report Generator
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: '#666666',
                  fontSize: '1rem'
                }}
              >
                Please sign in to continue
              </Typography>
            </Box>
          );
        },
        Footer() {
          return (
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#666666',
                  fontSize: '0.875rem'
                }}
              >
                Secure authentication powered by AWS Cognito
              </Typography>
            </Box>
          );
        }
      }}
      variation="default"
    >
      {({ signOut, user }) => {
        // If user is authenticated, render the main app
        if (user) {
          return <>{children}</>;
        }
        
        // If not authenticated, show the login form with AWS-themed styling
        return (
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#F5F5F5', // AWS light gray background
              padding: 2
            }}
          >
            <Container maxWidth="sm">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '60vh'
                }}
              >
                {/* The Authenticator form will be rendered here with custom styling */}
              </Box>
            </Container>
          </Box>
        );
      }}
    </Authenticator>
  );
};

export default LoginPage;